// extracted by mini-css-extract-plugin
var _1 = "yIDfHOOniP";
export { _1 as "root" }
